







import { UseTabs } from "@/common/composition/use-tabs";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import Vue from "vue";
import SecurityPolicies from "./security-policies/SecurityPolicies.vue";
export default Vue.extend({
  components: {
    PageWithMainContainer,
    SecurityPolicies,
  },
  setup() {
    const [tabs, current_tab, set_current_tab] = UseTabs(
      [
        {
          id: "security-policies",
          name: "Security Policies",
          icon: "File",
        },
      ],
      0
    );

    return {
      tabs,
      current_tab,
      set_current_tab,
    };
  },
});
